import type { ButtonProps } from '@src/shared/ui/Button';
import { Button } from '@src/shared/ui/Button';
import { forwardRef } from 'react';

const StyleShet = {
  button: (active: boolean) => ({
    color: active ? 'red.600' : '',
    width: '92px',
  }),
};

type TodayButtonProps = ButtonProps & { active: boolean };
const TodayButton = forwardRef<HTMLButtonElement, TodayButtonProps>(
  (props, ref) => {
    const { active, ...rest } = props;
    return (
      <Button
        ref={ref}
        {...rest}
        variant="outlined"
        color="secondary"
        sx={StyleShet.button(active)}
      >
        Today
      </Button>
    );
  },
);

export default TodayButton;
